import React from "react";
import { useNavigate } from "react-router-dom";
import Icon from "../../../components/AppIcon";
import { Play } from "lucide-react";

const NewAnalysisCard = () => {
  const navigate = useNavigate();

  return (
    <div
      className="relative w-full max-w-2xl mx-auto rounded-[28px] overflow-hidden
        bg-white/[0.04] backdrop-blur-2xl border border-white/10
        shadow-[0_30px_60px_rgba(0,0,0,0.5)] transition-all duration-500 hover:border-white/20"
      style={{ maxHeight: "62vh" }}
    >
      {/* Top glow */}
      <div className="pointer-events-none absolute -top-20 left-1/2 -translate-x-1/2 w-64 h-40 bg-blue-500/20 blur-3xl rounded-full" />
      {/* Upper reflection line */}
      <div className="absolute top-0 left-0 right-0 h-[1px] bg-gradient-to-r from-transparent via-white/15 to-transparent" />

      <div className="relative flex flex-col items-center p-10">
        {/* ICON */}
        <div className="flex justify-center mb-7">
          <div className="relative w-20 h-20 rounded-2xl flex items-center justify-center
            bg-gradient-to-br from-blue-600/30 to-cyan-500/20
            border border-blue-400/30 shadow-[0_0_30px_rgba(59,130,246,0.2)]">
            <Icon name="Plus" size={34} color="white" />
          </div>
        </div>

        {/* TITLE */}
        <h3 className="text-3xl font-light text-white text-center tracking-tight mb-2">
          Start New Analysis
        </h3>

        {/* DESCRIPTION */}
        <p className="text-slate-400 text-center text-sm leading-relaxed max-w-md mx-auto mb-8">
          Upload patient scalp images and instantly receive accurate,
          AI-powered graft counts and density mapping.
        </p>

        {/* BUTTON */}
        <button
          onClick={() => navigate("/new-analysis")}
          className="group flex items-center gap-3 px-10 py-3.5 rounded-2xl
            bg-blue-600 hover:bg-blue-500 text-white text-[15px] font-medium
            shadow-[0_8px_30px_rgba(37,99,235,0.35)] hover:shadow-[0_8px_30px_rgba(37,99,235,0.5)]
            transition-all duration-200 active:scale-[0.98] mb-4"
        >
          <Play size={16} className="group-hover:translate-x-0.5 transition-transform" />
          Start Patient Analysis
        </button>

        {/* FOOTER NOTE */}
        <p className="text-center text-[11px] text-white/25 tracking-wide">
          JPG, PNG, JPEG • Max 2 MB per image
        </p>
      </div>
    </div>
  );
};

export default NewAnalysisCard;
